window.Products.DeviceCase.Iphone7 = function() {
};
window.Products.DeviceCase.Iphone7.inherits(window.Products.DeviceCase.DeviceCase);
window.Products.DeviceCase.Iphone7.id = 56;
window.Products.DeviceCase.Iphone7.slug = 'iphone7';

window.Products.DeviceCase.Iphone7.prototype.set3dProperties = function(modelViewer) {
	this.updateThreeTexture(modelViewer);
	modelViewer.object.position.y = -0.66;
	modelViewer.camera.position.z = 8;
};

window.Products.DeviceCase.Iphone7.prototype.setThreeControls = function(controls) {
	controls.minDistance = 3.1;
	controls.maxDistance = 4.1;
};